/**
 * Pagos a Incautadores — pantalla unificada de pago y consulta.
 *
 * La vista principal es el listado de pagos realizados a incautadores
 * embebido (ares5090: filtros por chasis o fechas/sucursal, reimpresión de
 * recibos y export a Excel). La tarjeta "Pagar incautadores" (ares5085) abre
 * el formulario de pago con distribución de chasis en diálogo a pantalla
 * completa; al guardar, el listado se recarga.
 *
 * Sustituye las entradas de menú de pagosincautadores.js y
 * listapagosincautadores.js; ambos componentes se reutilizan.
 */
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import { useMaterialUIController } from "context";
import { FP, PageHeader, ActionCard } from "components/financepro";
import { tienePermisosModulo } from "lib/seguridad/permisosPorModulo";
import PagosIncautadores from "modules/incautos/pagosincautadores";
import ListaPagosIncautadores from "modules/incautos/listapagosincautadores";
import useAccionInicial from "lib/useAccionInicial";

export default function PagosIncautadoresUnificado() {
  const [controller] = useMaterialUIController();
  const { roleDetalles } = controller;

  // Permisos por programa ARES (el backend re-valida en permisos.py).
  const puedePagar = tienePermisosModulo(roleDetalles, "ares5085");
  const puedeListado = tienePermisosModulo(roleDetalles, "ares5090");

  const [pagoOpen, setPagoOpen] = useState(false);

  // Enlace profundo desde el buscador global (?accion=...).
  useAccionInicial({
    pagar: { permitido: puedePagar, abrir: () => setPagoOpen(true) },
  });

  // Incrementarlo recarga el listado embebido (tras registrar un pago).
  const [refreshKey, setRefreshKey] = useState(0);
  const refrescar = () => setRefreshKey((k) => k + 1);

  return (
    <Box component="main" sx={{ minHeight: "100vh", bgcolor: FP.color.surface }}>
      <PageHeader
        title="Pagos a Incautadores"
        subtitle="Paga a los incautadores y consulta los pagos realizados en un solo lugar"
      />

      <Box sx={{ p: { xs: 2, md: 3 } }}>
        {puedePagar && (
          <Grid container spacing={2.5} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <ActionCard
                icon={PaidOutlinedIcon}
                titulo="Pagar incautadores"
                descripcion="Incautos pagados por el cliente o cancelados, con distribución de chasis"
                color={FP.color.success}
                onClick={() => setPagoOpen(true)}
              />
            </Grid>
          </Grid>
        )}

        {/* Vista principal: listado de pagos a incautadores */}
        {puedeListado && <ListaPagosIncautadores embedded refreshToken={refreshKey} />}
      </Box>

      {/* Pagar incautadores (formulario completo a pantalla completa) */}
      <Dialog fullScreen open={pagoOpen} onClose={() => setPagoOpen(false)}>
        <PagosIncautadores embedded onExit={() => { setPagoOpen(false); refrescar(); }} onSaved={refrescar} />
      </Dialog>
    </Box>
  );
}
